if (!customElements.get('sticky-cart')) {
  class StickyCart extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = document.getElementById(this.dataset.formId);
      this.product = this.form && this.form.closest('.js-product');
      this.mainButton = this.form && this.form.querySelector('[name="add"]');
      this.button = this.querySelector('.btn--sticky-cart');
      if (!this.product || !this.mainButton || !this.button) return;
      this.initialized = true;
      this.price = this.product.querySelector('.product-price .price');
      this.priceContainer = this.querySelector('.sticky-cart-product-price');
      this.variantTitle = this.querySelector('[data-sticky-variant-title]');
      this.listeners = [];
      const listen = (target, name, callback, options) => {
        target.addEventListener(name, callback, options);
        this.listeners.push([target, name, callback, options]);
      };
      listen(this.button, 'click', (event) => {
        event.preventDefault();
        this.sync();
        if (this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true') return;
        if (this.form.requestSubmit) {
          this.form.requestSubmit(this.mainButton);
        } else {
          this.mainButton.click();
        }
        this.sync();
        if (!this.form.querySelector('[name="id"]').value && window.theme && theme.scrollToRevealElement) {
          theme.scrollToRevealElement(this.product.querySelector('variant-picker') || this.form);
        }
      });
      listen(this.product, 'on:variant:change', (event) => {
        if (event.detail && event.detail.form !== this.form) return;
        this.sync();
      });
      listen(this.product, 'on:cart:error', () => {
        this.sync();
        const error = this.product.querySelector('.js-form-error:not([hidden])');
        if (error && window.theme && theme.scrollToRevealElement) theme.scrollToRevealElement(error);
      });
      listen(document, 'on:cart-drawer:after-open', () => {
        this.drawerOpen = true;
        this.updateVisibility();
      });
      listen(document, 'on:cart-drawer:after-close', () => {
        this.drawerOpen = false;
        this.updateVisibility();
      });
      listen(document, 'on:quickbuy:after-open', () => {
        this.quickbuyOpen = true;
        this.updateVisibility();
      });
      listen(document, 'on:quickbuy:after-close', () => {
        this.quickbuyOpen = false;
        this.updateVisibility();
      });
      const scheduleVisibility = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateVisibility();
        });
      };
      listen(window, 'scroll', scheduleVisibility, { passive: true });
      listen(window, 'resize', scheduleVisibility);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.mainButton, { attributes: true, childList: true, subtree: true, characterData: true });
      if (this.price) this.observer.observe(this.price, { attributes: true, childList: true, subtree: true, characterData: true });
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(scheduleVisibility);
        this.resizeObserver.observe(this.product);
      }
      this.sync();
    }

    sync() {
      this.button.textContent = this.mainButton.textContent;
      this.button.disabled = this.mainButton.disabled;
      const ariaDisabled = this.mainButton.getAttribute('aria-disabled');
      if (ariaDisabled === null) {
        this.button.removeAttribute('aria-disabled');
      } else {
        this.button.setAttribute('aria-disabled', ariaDisabled);
      }
      ['is-loading', 'is-success'].forEach((state) => {
        this.button.classList.toggle(state, this.mainButton.classList.contains(state));
      });
      if (this.price && this.priceContainer && this.priceContainer.innerHTML !== this.price.outerHTML) {
        this.priceContainer.innerHTML = this.price.outerHTML;
      }
      const picker = this.product.querySelector('variant-picker');
      if (this.variantTitle && picker && Object.prototype.hasOwnProperty.call(picker, 'variant')) {
        this.variantTitle.textContent = picker.variant ? ` · ${picker.variant.title}` : '';
        this.variantTitle.hidden = !picker.variant;
      }
      this.updateVisibility();
    }

    updateVisibility() {
      const rect = this.mainButton.getBoundingClientRect();
      const headerHeight = window.theme && theme.stickyHeaderHeight ? theme.stickyHeaderHeight() : 0;
      const visible = rect.height > 0 && rect.bottom <= headerHeight && !this.drawerOpen && !this.quickbuyOpen;
      this.classList.toggle('visible', visible);
      this.setAttribute('aria-hidden', String(!visible));
      this.button.tabIndex = visible ? 0 : -1;
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.listeners.forEach(([target, name, callback, options]) => target.removeEventListener(name, callback, options));
      this.observer.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.initialized = false;
    }
  }
  customElements.define('sticky-cart', StickyCart);
}
document.addEventListener('DOMContentLoaded',function(){function initializeCarousel(sliderClass,productClass,prevBtnClass,nextBtnClass){const slider=document.querySelector(sliderClass);if(!slider)return;const products=slider.querySelectorAll(productClass);const prevBtn=document.querySelector(prevBtnClass);const nextBtn=document.querySelector(nextBtnClass);let isDragging=!1;let startX;let scrollLeft;slider.addEventListener('mousedown',startDragging);slider.addEventListener('touchstart',startDragging,{passive:!0});slider.addEventListener('mousemove',drag);slider.addEventListener('touchmove',drag,{passive:!0});slider.addEventListener('mouseup',stopDragging);slider.addEventListener('mouseleave',stopDragging);slider.addEventListener('touchend',stopDragging);if(prevBtn)prevBtn.addEventListener('click',()=>scrollToProduct('prev'));if(nextBtn)nextBtn.addEventListener('click',()=>scrollToProduct('next'));function startDragging(e){isDragging=!0;startX=e.pageX||e.touches[0].pageX;scrollLeft=slider.scrollLeft;slider.style.scrollBehavior='auto'}
function drag(e){if(!isDragging)return;e.preventDefault();const x=e.pageX||e.touches[0].pageX;const dist=x-startX;slider.scrollLeft=scrollLeft-dist}
function stopDragging(){isDragging=!1;slider.style.scrollBehavior='smooth';snapToClosestProduct()}
function snapToClosestProduct(){const productWidth=products[0].offsetWidth;const scrollPosition=slider.scrollLeft;const targetIndex=Math.round(scrollPosition/productWidth);const targetScroll=targetIndex*productWidth;slider.scrollTo({left:targetScroll,behavior:'smooth'})}
function scrollToProduct(direction){const productWidth=products[0].offsetWidth;const currentScroll=slider.scrollLeft;const targetScroll=direction==='next'?currentScroll+productWidth:currentScroll-productWidth;slider.scrollTo({left:targetScroll,behavior:'smooth'})}}
initializeCarousel('.maison-style-slider','.maison-style-product','.maison-prev-btn','.maison-next-btn');initializeCarousel('.cart-maison-style-slider','.cart-maison-style-product','.cart-maison-prev-btn','.cart-maison-next-btn');function initializeAddToCartForms(formClass,btnClass){const forms=document.querySelectorAll(formClass);forms.forEach(form=>{form.addEventListener('submit',function(event){event.preventDefault();const formData=new FormData(form);const xhr=new XMLHttpRequest();xhr.open('POST','/cart/add.js',!0);const button=form.querySelector(btnClass);const originalButtonText=button.textContent;button.textContent='Adding...';button.disabled=!0;xhr.onreadystatechange=function(){if(xhr.readyState===4){console.log('XHR request completed');if(xhr.status===200){const response=JSON.parse(xhr.responseText);console.log('Product added to cart:',response);document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh',{bubbles:!0}));setTimeout(function(){document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'))},1000)}else{console.error('Error adding product to cart:',xhr.responseText)}
setTimeout(function(){button.textContent=originalButtonText;button.disabled=!1},1000)}};xhr.onerror=function(){console.error('XHR request failed');button.textContent=originalButtonText;button.disabled=!1};xhr.setRequestHeader('X-Requested-With','XMLHttpRequest');xhr.send(formData)})})}
initializeAddToCartForms('.maison-product-form','.maison-add-to-cart-btn');initializeAddToCartForms('.cart-maison-product-form','.cart-maison-add-to-cart-btn')})